import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Clock, User, Loader2 } from "lucide-react";

export default function Blog() {
  const [blogs, setBlogs] = useState(null);
  const [cat, setCat] = useState("");
  useEffect(() => { api.get(`/blogs${cat ? `?category=${cat}` : ""}`).then((r) => setBlogs(r.data)); }, [cat]);
  const cats = ["Nutrition", "Ayurveda", "Organic Living", "Healthy Recipes", "Immunity", "Fitness"];

  return (
    <div>
      <section className="bg-sand leaf-pattern">
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-14 lg:py-20 text-center">
          <span className="text-terracotta font-500 text-sm uppercase tracking-wider">Stories & Guides</span>
          <h1 className="font-heading text-4xl lg:text-6xl text-forest tracking-tight mt-2">Wellness Blog</h1>
          <p className="text-brown/70 mt-4 max-w-2xl mx-auto">Nutrition tips, organic living, recipes and expert wellness advice for a healthier everyday life.</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-10">
        <div className="flex gap-2 flex-wrap mb-8">
          <button onClick={() => setCat("")} className={`px-4 py-1.5 rounded-full text-sm font-500 transition-colors ${!cat ? "bg-forest text-cream" : "bg-white text-brown border border-sage/40"}`}>All</button>
          {cats.map((c) => <button key={c} onClick={() => setCat(c)} data-testid={`blog-cat-${c}`} className={`px-4 py-1.5 rounded-full text-sm font-500 transition-colors ${cat === c ? "bg-forest text-cream" : "bg-white text-brown border border-sage/40"}`}>{c}</button>)}
        </div>
        {!blogs ? <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-forest" /></div> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {blogs.map((b) => (
              <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-${b.id}`} className="group bg-white rounded-[28px] overflow-hidden soft-shadow hover:soft-shadow-lg transition-shadow">
                <div className="aspect-[16/10] overflow-hidden bg-sand"><img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
                <div className="p-5">
                  <span className="text-xs bg-mustard/25 text-brown px-3 py-1 rounded-full font-500">{b.category}</span>
                  <h3 className="font-heading text-2xl text-forest mt-3 leading-tight group-hover:text-terracotta transition-colors">{b.title}</h3>
                  <p className="text-sm text-brown/70 mt-2 line-clamp-2">{b.excerpt}</p>
                  <div className="flex items-center gap-4 mt-4 text-xs text-muted-foreground"><span className="inline-flex items-center gap-1"><User className="w-3.5 h-3.5" />{b.author}</span><span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5" />{b.read} min read</span></div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
